import {MaterialStoragesHistory} from '@hconnect/common/types'
import {Moment} from 'moment-timezone'

import {toRecord} from '../../../helpers/utils'
import {useUrlParam} from '../../../hooks/useUrlParam'
import {getStoragesFromHistory} from '../../../selectors/storages'
import {MomentRange} from '../../../selectors/time'
import {usePlannerQuery} from '../usePlannerQuery'

interface HistoryStoragesWithMaterialQueryParams {
  timeFrame: MomentRange
  date?: Moment
  throwOnError?: boolean
}

export const useHistoryStoragesByIdQuery = ({
  timeFrame: [from, to],
  date,
  throwOnError = true
}: HistoryStoragesWithMaterialQueryParams) => {
  const plantCode = useUrlParam('plantCode')
  return usePlannerQuery(
    'materialStorageHistory',
    [plantCode, from.toISOString(), to.toISOString()],
    {
      select: (storagesHistory: MaterialStoragesHistory) => {
        return toRecord(getStoragesFromHistory(storagesHistory, date ?? to), 'id')
      },
      throwOnError
    }
  )
}
